const isStaging = process.env.APP_ENV === 'staging';
export const EMPLOYERS_LINK =
  'https://www.metlife.com/business-and-brokers/employee-benefits/legal-services/';

export const LOGIN = isStaging
  ? 'https://staging.login.legalplans.com/login'
  : 'https://login.legalplans.com/login';

export const REGISTER = isStaging
  ? 'https://staging.login.legalplans.com/register'
  : 'https://login.legalplans.com/register';

export const CALCULATOR = 'https://www.legalplans.com/calculator';

export const AMAZON_ESTATE_REGISTRATION = isStaging
  ? 'https://staging.members.legalplans.com/?digitalEstatePlanning=amazon'
  : 'https://members.legalplans.com/?digitalEstatePlanning=amazon';

export const CAREERS =
  'https://workforcenow.adp.com/mascsr/default/mdf/recruitment/recruitment.html?cid=269ead05-4042-4cc5-b325-75a73a6e0439&ccId=19000101_000001&lang=en_US';

export const FEDERAL_BENEFITS =
  'https://www.metlife.com/federal/legal/?BTID=Header_FedLegal_LegalPlansHome_ForFedGovt';

export const DEP_LITE_REGISTRATION = isStaging
  ? 'https://staging.login.legalplans.com/register?service=digitalEstatePlanning&next=https%3A%2F%2Fstaging.wills.legalplans.com%2Fregister%3Fservice%3DdigitalEstatePlanning'
  : 'https://login.legalplans.com/register?service=digitalEstatePlanning&next=https%3A%2F%2Fwills.legalplans.com%2Fregister%3Fservice%3DdigitalEstatePlanning';
